import { Grid } from '@mui/material';

import { Position } from '@work4all/models/lib/Classes/Position.entity';

import { Panel } from '../../../../../components/panel/Panel';
import { Assignment } from '../general/components/assignment/Assignment';
import { Description } from '../general/components/description/Description';
import { ParticipantsAndAddresses } from '../general/components/participants-and-addresses/ParticipantsAndAddresses';

import { Payment } from './components/payment/Payment';
import { PerformancePeriod } from './components/performance-period/PerformancePeriod';

type Props = {
  positionList: Position[];
};

export const MiscellaneousTabPanel = ({ positionList }: Props) => {
  return (
    <Panel restrictedWidth>
      <Grid container>
        <Grid item xs={12}>
          <Description positionList={positionList} />
        </Grid>
        <Grid item xs={12}>
          <Assignment />
        </Grid>
      </Grid>

      <ParticipantsAndAddresses displayAsSection />
      <Payment />
      <PerformancePeriod />
    </Panel>
  );
};
